import { jsx } from "react/jsx-runtime";
import GroupsIcon from "@mui/icons-material/Groups";
import { validateTidalLicense } from "../../base/index.js";
function Groups(props) {
  return /* @__PURE__ */ jsx(
    GroupsIcon,
    {
      "data-testid": "Groups",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Groups",
      "data-tidal-icon-meta": "people,persona"
    }
  );
}
Groups.tidalIconMeta = {
  categories: "people,persona",
  name: "Groups"
};
validateTidalLicense();
export {
  Groups
};
//# sourceMappingURL=Groups.js.map
